<app-authview-header/>

<div class="minFullHeight">
    <div class="mx-auto">
        <main class="mediumContainer">
            <div class="dashboardContent">
                <div class="flex-col">
                    <mat-card class="mb-10" style="overflow: hidden;">
                        <mat-card-header [style.background-color]="community?.community_stats_header_bg_color_hex"
                                         class="accentHeader">
                            <mat-card-title
                                    [style.color]="themeService.getReadableColor(community?.community_stats_header_bg_color_hex)"
                                    class="pb-10">
                                Email Verification Required
                            </mat-card-title>
                        </mat-card-header>
                        @if (!emailVerificationSended) {
                            <ng-container
                                    [ngTemplateOutlet]="sendEmailTemplate"></ng-container>
                        }
                        @if (emailVerificationSended) {
                            <ng-container [ngTemplateOutlet]="verifyEmail"></ng-container>
                        }
                    </mat-card>
                </div>
            </div>
        </main>
    </div>
</div>

<app-footer></app-footer>

<ng-template #sendEmailTemplate>
    <mat-card-content>
        <div class="description mt-20">
            Hi {{ userName }},<br>
            To keep your information secure and up-to-date, please verify your email address: <b>{{ email }}</b>. If
            you've already done so, you can (re)verify it to ensure your account remains active and accessible. Thank
            you for taking this step to protect your account!
        </div>
    </mat-card-content>
    <mat-card-footer>
        <mat-card-actions class="text-center mt-20">
            <button (click)="sendEmail()" [disabled]="loading"
                    class="mx-auto"
                    color="accent" mat-flat-button>
                Send email
                @if (loading) {
                    <mat-icon>
                        <mat-spinner color="accent"></mat-spinner>
                    </mat-icon>
                }
            </button>
        </mat-card-actions>
    </mat-card-footer>
</ng-template>

<ng-template #verifyEmail>
    <mat-card-content>
        <div class="description mt-20">
            Please enter the verification code you received in your email into the field below to complete the
            verification process. This helps ensure the security of your account.
        </div>
        <mat-form-field class="w-100 mt-10" color="accent">
            <mat-label>Verification code</mat-label>
            <input [(ngModel)]="verificationCode" matInput type="text">
        </mat-form-field>

        <div class="description flex-row gap-10 align-items-center mt-10">
            Dont get email?
            <a (click)="sendEmail()" class="resend-btn">
                Resend it
            </a>
        </div>
    </mat-card-content>
    <mat-card-footer>
        <mat-card-actions class="text-center mt-20">
            <button (click)="verify()" [disabled]="loading"
                    class="mx-auto"
                    color="accent" mat-flat-button>
                Verify email
                @if (loading) {
                    <mat-icon>
                        <mat-spinner color="accent"></mat-spinner>
                    </mat-icon>
                }
            </button>
        </mat-card-actions>
    </mat-card-footer>
</ng-template>
